module.exports = __webpack_public_path__ + "img/2_252.ce2a8659.png";